// components/ShareholderReturns.jsx
export default function ShareholderReturns({ company, data }) {
  if (!data) return null;

  const { dividend, dividendYield, eps } = data;

  const parts = [];

  if (dividend != null) {
    parts.push(
      <>declared a dividend of <strong>Rs {dividend}</strong></>
    );
  }

  if (dividendYield != null) {
    parts.push(
      <>resulting in a dividend yield of <strong>{dividendYield}%</strong></>
    );
  }

  if (eps != null) {
    parts.push(
      <>the latest EPS stands at <strong>Rs {eps}</strong></>
    );
  }

  if (!parts.length) return null;

  return (
    <p className="mb-5">
      Shareholder return metrics such as Dividend Yield and Earnings Per Share
      (EPS) provide insight into income distribution.{" "}
      <strong>{company}</strong>{" "}
      {parts.map((part, index) => (
        <span key={index}>
          {index > 0 && ", "}
          {part}
        </span>
      ))}
      .
    </p>
  );
}
